import gql from "graphql-tag";

export const allOrders = gql`
  query allOrders(
    $notPlanned: Boolean
    $pickupDateAfter: Date
    $pickupDateBefore: Date
  ) {
    allOrders(
      filter: {
        shipmentId: { isNull: $notPlanned }
        pickupDate: {
          greaterThanOrEqualTo: $pickupDateAfter
          lessThanOrEqualTo: $pickupDateBefore
        }
      }
    ) {
      nodes {
        id
        packingCode
        loadingOrder
        boxes
        boxesControle
        boxesTransit
        brutto
        netto
        chargableWeight
        awb
        hawb
        flight
        amountPallets
        pickupDate
        pickupTime
        about
        tags
        shipmentByShipmentId {
          date
          relationByRelationId {
            name
          }
          carrierByCarrierId {
            id
            truck
            trailer
          }
        }
        relationBySellerId {
          id
          role
          name
          code
          adres
          postindex
          city
          countryId
          vat
          eori
          kvk
          status
          loadingAddr
          loadingRoute
          doorCode
          about
          contactsByRelationId {
            nodes {
              id
              name
              department
              salesReference
              telWork
              telMobile
              email
              skype
            }
          }
          countryByCountryId {
            id
            nicename
            iso
            name
          }
        }
        relationByBuyerId {
          id
          role
          name
          code
          adres
          postindex
          city
          countryId
          vat
          eori
          kvk
          status
          loadingAddr
          loadingRoute
          doorCode
          about
          contactsByRelationId {
            nodes {
              id
              name
              department
              salesReference
              telWork
              telMobile
              email
              skype
            }
          }
          countryByCountryId {
            id
            nicename
            iso
            name
          }
        }
        relationByLoadAtId {
          id
          role
          name
          code
          adres
          postindex
          city
          countryId
          vat
          eori
          kvk
          status
          loadingAddr
          loadingRoute
          doorCode
          about
          contactsByRelationId {
            nodes {
              id
              name
              department
              salesReference
              telWork
              telMobile
              email
              skype
            }
          }
          countryByCountryId {
            id
            nicename
            iso
            name
          }
        }
        relationByShipperId {
          id
          role
          name
          code
          adres
          postindex
          city
          countryId
          vat
          eori
          kvk
          status
          loadingAddr
          loadingRoute
          doorCode
          about
          contactsByRelationId {
            nodes {
              id
              name
              department
              salesReference
              telWork
              telMobile
              email
              skype
            }
          }
          countryByCountryId {
            id
            nicename
            iso
            name
          }
        }

        storagesByOrderId {
          nodes {
            id
            fileName
            fileSize
            fileType
            url
          }
        }
        cargoTypeByCargoTypeId {
          id
          code
          type
        }
        packingTypeByPackingId {
          id
          type
          coefficient
        }
        countryByCountryId {
          id
          name
          nicename
          iso
        }
        shipmentId
        sellerId
        loadAtId
        buyerId
        shipperId
        packingId
        countryId
        cargoTypeId
      }
    }
  }
`;

export const createOrder = gql`
  mutation(
    $shipmentId: Int
    $sellerId: Int
    $loadAtId: Int
    $buyerId: Int
    $shipperId: Int
    $checked: Boolean
    $packingCode: String
    $loadingOrder: Int
    $packingId: Int
    $boxes: Int
    $boxesControle: String
    $boxesTransit: BigFloat
    $brutto: Int
    $netto: Int
    $chargableWeight: Int
    $awb: String
    $hawb: String
    $flight: String
    $countryId: Int
    $amountPallets: BigFloat
    $documentType: String
    $mrnNumber: String
    $pickupDate: Date
    $pickupTime: Time
    $about: String
    $invoiceValue: BigFloat
    $cargoTypeId: Int
  ) {
    createOrder(
      input: {
        order: {
          shipmentId: $shipmentId
          sellerId: $sellerId
          loadAtId: $loadAtId
          buyerId: $buyerId
          shipperId: $shipperId
          checked: $checked
          packingCode: $packingCode
          loadingOrder: $loadingOrder
          packingId: $packingId
          boxes: $boxes
          boxesControle: $boxesControle
          boxesTransit: $boxesTransit
          brutto: $brutto
          netto: $netto
          chargableWeight: $chargableWeight
          awb: $awb
          hawb: $hawb
          flight: $flight
          countryId: $countryId
          amountPallets: $amountPallets
          documentType: $documentType
          mrnNumber: $mrnNumber
          pickupDate: $pickupDate
          pickupTime: $pickupTime
          about: $about
          invoiceValue: $invoiceValue
          cargoTypeId: $cargoTypeId
        }
      }
    ) {
      order {
        id
        shipmentId
      }
    }
  }
`;

export const updateOrderById = gql`
  mutation(
    $id: Int!
    $shipmentId: Int
    $sellerId: Int
    $loadAtId: Int
    $buyerId: Int
    $shipperId: Int
    $packingCode: String
    $checked: Boolean
    $loadingOrder: Int
    $packingId: Int
    $boxes: Int
    $boxesControle: String
    $boxesTransit: BigFloat
    $brutto: Int
    $netto: Int
    $chargableWeight: Int
    $awb: String
    $hawb: String
    $flight: String
    $countryId: Int
    $amountPallets: BigFloat
    $documentType: String
    $mrnNumber: String
    $pickupDate: Date
    $pickupTime: Time
    $about: String
    $invoiceValue: BigFloat
    $cargoTypeId: Int
  ) {
    updateOrderById(
      input: {
        id: $id
        orderPatch: {
          shipmentId: $shipmentId
          sellerId: $sellerId
          loadAtId: $loadAtId
          buyerId: $buyerId
          shipperId: $shipperId
          packingCode: $packingCode
          checked: $checked
          loadingOrder: $loadingOrder
          packingId: $packingId
          boxes: $boxes
          boxesControle: $boxesControle
          boxesTransit: $boxesTransit
          brutto: $brutto
          netto: $netto
          chargableWeight: $chargableWeight
          awb: $awb
          hawb: $hawb
          flight: $flight
          countryId: $countryId
          amountPallets: $amountPallets
          documentType: $documentType
          mrnNumber: $mrnNumber
          pickupDate: $pickupDate
          pickupTime: $pickupTime
          about: $about
          invoiceValue: $invoiceValue
          cargoTypeId: $cargoTypeId
        }
      }
    ) {
      order {
        id
      }
    }
  }
`;

export const deleteOrderById = gql`
  mutation deleteOrderById($id: Int!) {
    deleteOrderById(input: { id: $id }) {
      deletedOrderId
    }
  }
`;

export const ordersByShipmentId = gql`
  query ordersByShipmentId($id: Int) {
    allOrders(condition: { shipmentId: $id }) {
      nodes {
        id
        packingCode
        loadingOrder
        boxes
        boxesControle
        boxesTransit
        brutto
        netto
        chargableWeight
        awb
        hawb
        flight
        pickupDate
        about
        tags
        relationBySellerId {
          id
          role
          name
          code
          adres
          postindex
          city
          countryId
          vat
          eori
          kvk
          status
          loadingAddr
          loadingRoute
          doorCode
          about
          contactsByRelationId {
            nodes {
              id
              name
              department
              salesReference
              telWork
              telMobile
              email
              skype
            }
          }
          countryByCountryId {
            id
            nicename
            iso
            name
          }
        }
        relationByBuyerId {
          id
          role
          name
          code
          adres
          postindex
          city
          countryId
          vat
          eori
          kvk
          status
          loadingAddr
          loadingRoute
          doorCode
          about
          contactsByRelationId {
            nodes {
              id
              name
              department
              salesReference
              telWork
              telMobile
              email
              skype
            }
          }
          countryByCountryId {
            id
            nicename
            iso
            name
          }
        }
        relationByLoadAtId {
          id
          role
          name
          code
          adres
          postindex
          city
          countryId
          vat
          eori
          kvk
          status
          loadingAddr
          loadingRoute
          doorCode
          about
          contactsByRelationId {
            nodes {
              id
              name
              department
              salesReference
              telWork
              telMobile
              email
              skype
            }
          }
          countryByCountryId {
            id
            nicename
            iso
            name
          }
        }
        relationByShipperId {
          id
          role
          name
          code
          adres
          postindex
          city
          countryId
          vat
          eori
          kvk
          status
          loadingAddr
          loadingRoute
          doorCode
          about
          contactsByRelationId {
            nodes {
              id
              name
              department
              salesReference
              telWork
              telMobile
              email
              skype
            }
          }
          countryByCountryId {
            id
            nicename
            iso
            name
          }
        }
        storagesByOrderId {
          nodes {
            id
            fileName
            fileSize
            fileType
            url
          }
        }
        cargoTypeByCargoTypeId {
          id
          type
          code
        }
        packingTypeByPackingId {
          id
          type
        }
        countryByCountryId {
          id
          name
          nicename
          iso
        }
        shipmentId
        sellerId
        loadAtId
        buyerId
        shipperId
        packingId
        countryId
        cargoTypeId
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/orders.js